import { render, staticRenderFns } from "./ROICalculator.vue?vue&type=template&id=37a22056&scoped=true"
import script from "./ROICalculator.vue?vue&type=script&lang=js"
export * from "./ROICalculator.vue?vue&type=script&lang=js"
import style0 from "./ROICalculator.vue?vue&type=style&index=0&id=37a22056&prod&lang=scss&scoped=true"
import style1 from "./ROICalculator.vue?vue&type=style&index=1&id=37a22056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a22056",
  null
  
)

export default component.exports